import { type PropsWithChildren } from 'react';

import { getText } from '@storebrand-digital/fms-translations';

import { Product } from '@app/types/enums';

import useProduct from '../../../app/hooks/useProduct';

export default function ProductRedirectorGuard({
  children,
  isBankCustomer,
}: PropsWithChildren<{ isBankCustomer: boolean | null | undefined }>) {
  const product = useProduct();

  if (product === Product.STANDARD_BANK && isBankCustomer) {
    window.location.href = getText('productRedirectorGuard.standardBankIsCustomerRedirectHref');
    return null;
  }

  return <>{children}</>;
}
